import React from 'react';
import { Card } from '../ui/Card';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, action, children, className }) => {
  return (
    <Card title={title} subtitle={subtitle} action={action} className={className}>
      <div className="w-full" style={{ minHeight: 250 }}>
        {children}
      </div>
    </Card>
  );
};
